module.exports = __webpack_public_path__ + "img/guardian004.1db5f0c5.jpg";